import { useEffect } from 'react'
import { classes, style } from 'typestyle'
import { ChildcareCard } from '../../routes/childcares/components/childcare-card'
import { Box } from '../../__aeki__/components/box/box.component'
import { Grid } from '../../__aeki__/components/grid/grid'
import { GridItem } from '../../__aeki__/components/grid/grid-item'
import { Modal } from '../../__aeki__/components/modal'
import { createCustomMediaQuery } from '../../__aeki__/components/style-class/style-class.utils'

/* Core ========================================================================================= */
import { addSnippet } from '../../__aeki__/core/snippet-manager'

/* Hooks ======================================================================================== */
import useFetch from '../../__aeki__/hooks/use-fetch'

/* Components =================================================================================== */
import { Snippet, SnippetBody, SnippetHead } from '../../__aeki__/modules/layouts/snippet'
import { fill } from '../../__aeki__/styles/styleset/fill/fill'
import '../../modals/childcare'
import '../../modals/childcare-contact'

/* Styles ======================================================================================= */
import { pt16 } from '../../__aeki__/styles/styleset/padding/pt16'
import { Text } from '../../__aeki__/components/text/text.component'
import { Line } from '../../__aeki__/components/line'
import { mt4 } from '../../__aeki__/styles/styleset/margin/mt4'
import { mb4 } from '../../__aeki__/styles/styleset/margin/mb4'
import { mb12 } from '../../__aeki__/styles/styleset/margin/mb12'

export default addSnippet('SavedList', (props: any) => {
  const apiUrl = `${process.env.REACT_APP_API_URL}/a/user/base/saved-list/table`
  const [data, $data] = useFetch(
    {
      data: [],
    },
    { url: apiUrl, search: { lookups: [{ key: 'body.groupId' }] } },
  )

  const childcaresUrl = `${process.env.REACT_APP_API_URL}/a/childcares/filters`
  const [childcares, $childcares] = useFetch(
    {
      filters: {},
    },
    { url: childcaresUrl },
  )

  useEffect(() => {
    if (data.mounted) {
      $data.get()
    }
  }, [data.mounted])

  useEffect(() => {
    if (childcares.mounted) {
      $childcares.get()
    }
  }, [childcares.mounted])

  return (
    <Snippet>
      <SnippetHead title={'My Saved List'} />
      <Line className={mb12} />
      <SnippetBody>
        <>
          {data.payload.data.length === 0 && !data.meta.isLoading && (
            <Text size="sm" italic>
              My Saved List is Empty.
            </Text>
          )}
          {data.payload.data.length > 0 && (
            <Box rounded className={classes(style({ overflow: 'hidden' }), pt16)} baseline="none">
              {data.payload.data.map((item: any, key: any) => {
                const reference = null

                const ccp = item.body.groupId
                if (ccp) {
                  ccp.watched = true
                }

                return (
                  <GridItem key={key}>
                    <Box row>
                      <ChildcareCard
                        classNameImage={GridItemStyle}
                        ccp={ccp}
                        reference={reference}
                        index={key}
                        key={key}
                        refresh={() => $data.get()}
                        allowWatch={false}
                        allowDelete={true}
                        filters={childcares.payload?.filters}
                        focused
                        onClick={() => {
                          Modal.push({
                            type: 'Childcare',
                            componentProps: {
                              ccp,
                              allowWatch: false,
                              filters: childcares.payload?.filters,
                            },
                          })
                        }}
                        onLocation={(coords: any) => {
                          window.open(
                            `/a/childcares?center.0=${`${coords[0]}`.replace(
                              '.',
                              '_',
                            )}&center.1=${`${coords[1]}`.replace('.', '_')}&page=1`,
                          )
                        }}
                        simplify
                      />
                      <Line className={mt4} />
                    </Box>
                  </GridItem>
                )
              })}
            </Box>
          )}
        </>
      </SnippetBody>
    </Snippet>
  )
})

const GridItemStyle = classes(
  style({
    height: 240,
    $nest: {
      ...createCustomMediaQuery({
        maxWidth: 1240,
        style: { maxHeight: 200, minHeight: 200 },
      }),
      ...createCustomMediaQuery({
        maxWidth: 992,
        style: { maxHeight: 200, minHeight: 200 },
      }),
      ...createCustomMediaQuery({
        maxWidth: 720,
        style: { maxHeight: 200, minHeight: 200 },
      }),
      ...createCustomMediaQuery({
        maxWidth: 520,
        style: { maxHeight: 200, minHeight: 200 },
      }),
    },
  }),
)
